<template>
  <div id="app">
      <div class="pass-info-msg">
          <p><span>温馨提示：</span></p>
          <p class="pass-info-tishi" >1、您的每个聊天号都单独对应一个密码，
            且不能重复。<br/> 
          2、为确保您的隐私，<b>密码无法找回</b>请您务必牢记聊天<br/>
          号对应的密码
          </p>
        </div>
  </div>
</template>
<script>
import headBack from "../common/head-back";

export default {
  name: "app",
  data() {
    return {
      msg: ""
    };
  },
  components: {
    headBack
  }
};
</script>
<style  scoped>

.pass-info-msg{
  width:100%;
  height: 240px;
  padding: 92px 60px 0px 81px;
  text-align: left;
}

.pass-info-msg b{
  color: #5C92FF;
}
.pass-info-msg span{
  width:160px;
  height:44px;
  font-size:32px;
  font-family:PingFangSC-Semibold,PingFang SC;
  font-weight:600;
  color:rgba(92,146,255,1);
  line-height:44px;
}

.pass-info-msg span:before{
  background-image:url('../../assets/img/deng@2x.png');
  content: "";
  display: inline-block;
  width: 36px;
  height: 36px;
  margin-right: 2px;
  vertical-align: middle;
  background-size: 100%;
  margin: -8px 12px 0px 0px;

}
.pass-info-tishi{
  width:100%;
  height:182px;
  font-size:24px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(122,124,135,1);
  line-height:42px;
  margin: -20px 0 0 0;

}

</style>


// WEBPACK FOOTER //
// src/components/common/passMsg.vue